import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tip } from '@model';
import * as fromAccountStore from '@appStore/account';

@Component({
    selector: 'app-tip-item',
    templateUrl: './tip-item.component.html',
    standalone: false
})
  export class TipItemComponent implements OnInit {
    @Input()
    tip: Tip
    @Output()
    hide = new EventEmitter<Tip>();
    @Output()
    navigate = new EventEmitter<Tip>();

    constructor(
      private accountStore: Store<fromAccountStore.State>
      ){}

    ngOnInit(): void {
        
        
    }

    onHideClick(){
      this.hide.emit(this.tip);
    }

    onNavigateClick(): void{
      this.navigate.emit(this.tip);
    }
  }
